export enum RequisitionReasons {
    NONE = "",
    ACCION_REALIZADA = "Acción Realizada",              // 1
    RECHAZADO_AD = "Rechazado AD",
    DESESTIMADO_F = "Desestimado F",
    NO_AUTORIZADO = "No autorizado",
    SIN_RESPUESTA_F = "Sin respuesta F",
    AUTORIZADO = "Autorizado",                          // 6
}